module.exports = __webpack_public_path__ + "img/icon-46.9c8fd929.svg";